import React from "react";

const ImageRenderer = ({ data, className = "" }) => {
  console.info(data);
  const { withBorder, file, caption } = data;
  return (
    <figure>
      <img
        src={`${process.env.GATSBY_STRAPI_API_URL}${file.url}`}
        className={withBorder ? "border-2 border-orange" : ""}
      />
      <figcaption>{caption}</figcaption>
    </figure>
  );
};
export default ImageRenderer;
